import React, { memo, useCallback, useEffect, useState } from 'react';
import { Form, InputGroup, Modal, Spinner } from 'react-bootstrap';
import { Search } from 'react-ionicons';
import FileExplorer from './FileExplorer';
import { useDebounce } from 'use-debounce';
import { searchFile } from '../../api/actions/Documents';
import { toast } from 'react-toastify';

export const ExplorerSearchButton = ({ onClick }) => {
    return (
        <div
            onClick={onClick}
            className="border rounded-3 px-3 py-2 d-flex align-items-center cursor-pointer"
        >
            <Search style={{ opacity: 0.6 }} width={'16px'} height={'16px'} />
            <span className="ps-2" style={{ fontSize: 14, opacity: 0.6 }}>
                Search a file
            </span>
        </div>
    );
};

const ExplorerSearchModal = ({ show, onClose }) => {
    const [files, setFiles] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [searchText, setSearchText] = useState('');

    const [debouncedValue] = useDebounce(searchText, 1000);

    useEffect(() => {
        if (show) {
            setFiles([]);
            setSearchText('');
            setIsLoading(false);
        }
    }, [show]);

    const fetchFiles = useCallback(async () => {
        if (debouncedValue.length === 0) {
            return;
        }

        setIsLoading(true);

        try {
            const response = await searchFile(debouncedValue);

            setFiles(response.data);
        } catch (error) {
            console.error(error);
            toast.error(
                'Something wrong happened while searching files. Please try again.',
                {
                    className: 'custom-toast',
                }
            );
        } finally {
            setIsLoading(false);
        }
    }, [debouncedValue]);

    useEffect(() => {
        fetchFiles();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [debouncedValue]);

    const onChange = useCallback((event) => {
        let { value } = event.target;

        setSearchText(value);
    }, []);

    const onSubmitSearch = useCallback((event) => {
        event.preventDefault();
    }, []);

    return (
        <Modal show={show} onHide={onClose} size="xl">
            <Modal.Header closeButton>Search file</Modal.Header>
            <Modal.Body>
                <div style={{ width: '100%', minHeight: 400 }}>
                    <div
                        style={{ width: '100%' }}
                        className="d-flex justify-content-center"
                    >
                        <Form onSubmit={onSubmitSearch}>
                            <InputGroup>
                                <InputGroup.Text>
                                    <Search />
                                </InputGroup.Text>
                                <Form.Control
                                    value={searchText}
                                    onChange={onChange}
                                    type="text"
                                    placeholder="Search for a file"
                                    style={{ width: 400 }}
                                />
                            </InputGroup>
                        </Form>
                    </div>
                    {!isLoading &&
                        debouncedValue.length > 0 &&
                        files.length === 0 && (
                            <div className="d-flex justify-content-center py-5">
                                <p className="pt-5 opacity-75">
                                    No file available
                                </p>
                            </div>
                        )}
                    {isLoading && (
                        <div
                            className="d-flex justify-content-center loader-icon"
                            style={{ marginTop: 120 }}
                        >
                            <Spinner color={'inherit'} />
                        </div>
                    )}
                    {!isLoading && files.length > 0 && (
                        <div
                            style={{
                                marginTop: 48,
                                paddingBottom: 48,
                                height: 600,
                                overflow: 'auto',
                            }}
                            className="px-4 pt-4"
                        >
                            <FileExplorer files={files} />
                        </div>
                    )}
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default memo(ExplorerSearchModal);
